import styles from './loading.module.css';

export default function Loading({style={}}) {
  return (
    <div className={styles.loader} style={style}></div>
  )
}
